//export const API_URL = 'http://localhost:3000';

export const API_URL = 'https://crafty-shield-416614.oa.r.appspot.com/';
